import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import BookingsTable from "@/features/bookings/bookings-table";

const bookingsSearchSchema = z.object({
  includeCancelled: fallback(z.boolean().optional(), undefined),
});

export const Route = createFileRoute(
  "/_app/(single-location)/museum/$museumId/bookings/",
)({
  component: Index,
  validateSearch: zodValidator(bookingsSearchSchema),
  beforeLoad: ({ context }) => {
    const canReadBookings = context.ability.can("read", "Booking");

    if (!canReadBookings) {
      console.error("User does not have permission to read bookings");
      redirect({
        to: "/unauthorized",
        throw: true,
      });
    }
  },
});

function Index() {
  const { includeCancelled } = Route.useSearch();
  const { museumId } = Route.useParams();

  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Bookinger</Trans>
        </h1>
      </Flex>

      <BookingsTable includeCancelled={includeCancelled} museumId={museumId} />
    </Box>
  );
}
